/**
 * 消息组件
 */

import { useState, useEffect } from 'react';

const x = ["星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"];

const Node = () => {
    const [time, setTime] = useState('');
    const [week, setWeek] = useState('');

    useEffect(() => {
        setTimeout(function () {
            let today = new Date();
            let time = today.getFullYear() + '年'
            time += (today.getMonth() + 1) + '月'
            time += today.getDate() + '日 '
            time += today.getHours() < 10 ? ('0' + today.getHours()) : today.getHours()
            time += ':' + (today.getMinutes() < 10 ? ('0' + today.getMinutes()) : today.getMinutes()) + ':'
            time += today.getSeconds() < 10 ? ('0' + today.getSeconds()) : today.getSeconds()
            let week = x[today.getDay()];
            setTime(time);
            setWeek(week);
        }, 1000);
    }, [time, week]);

    return (
        <>
            <h4>{week}, {time}</h4>
            <span>欢迎回到新致腾控制台，您准备好了吗？</span>
        </>
    );

}
export default Node;